const { __ } = wp.i18n;
const { InspectorControls } = wp.blockEditor;
const { useState, useEffect } = wp.element;
const { TextareaControl, PanelBody, __experimentalHeading, TextControl, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useBlockProps } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import { html } from '@wordpress/icons';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import ShortUniqueId from 'short-unique-id';
import { textColor } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import DisplayControl from '../../controls/display/display.js';
import BacgroundControl from '../../controls/background/background.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import AceCode from '../../controls/ace-editor/ace-editor.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import DOMPurify from 'dompurify';
import './custom-html.css'; 

wp.blocks.registerBlockType('softlite-io-integration/custom-html', {
    apiVersion: 3,
    title: __('Custom HTML'),
    icon: html,
    category: 'softlite-io-integration',
    attributes: addAttributeResponsive(attributes),
    edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const { id, custom_attributes } = attributes;
        const [tag, setTag] = useState(attributes?.customHTML?.parentTag ? attributes?.customHTML?.parentTag : 'div');
        const [attributeCustom, setAttributeCustom] = useState({});
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        const currentDevice = useSelect((select) => {
            return select('core/edit-post').__experimentalGetPreviewDeviceType();
        }, []);
        const device = currentDevice.toLowerCase();
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            setAttributes({ css: newCss });
            setCss(replaceBackgroundImage(cssCustomString + newCss, softliteData.site_url));
            setAttributeCustom(getCustomAttribute(custom_attributes));
        }, [attributes]);

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const handleChangeNewHtml = (newHTML, CssDevice) => {
            setAttributes({
                customHTML: {
                    ...attributes?.customHTML,
                    htmlContent: newHTML
                }
            });
        }

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';

        const blockProps = useBlockProps({
            className: 'softlite-block-custom-html' + (attributes?.customHTML?.htmlContent === '' ? ' softlite-block-empty' : '') + advancedClassNames,
        });

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <PanelBody title={__('Settings')} opened={openSettingSection === 'settings'} onToggle={() => handleToggle('settings', 'openSettingSection')}>
                                    <label>Custom HTML:</label>
                                    <div style={{ marginTop: '5px' }}>
                                        <AceCode
                                            value={attributes?.customHTML?.htmlContent}
                                            onChange={handleChangeNewHtml}
                                            mode="html"
                                            placeholder="Enter your html here"
                                        />
                                    </div>
                                    <SelectControl
                                        label="Parent Tag"
                                        value={attributes?.customHTML?.parentTag}
                                        options={[
                                            { label: 'div', value: 'div' },
                                            { label: 'section', value: 'section' },
                                            { label: 'article', value: 'article' },
                                            { label: 'nav', value: 'nav' },
                                            { label: 'ol', value: 'ol' },
                                            { label: 'ul', value: 'ul' },
                                            { label: 'li', value: 'li' },
                                            { label: 'aside', value: 'aside' },
                                            { label: 'address', value: 'address' },
                                            { label: 'figure', value: 'figure' },
                                            { label: 'figcaption', value: 'figcaption' },
                                            { label: 'p', value: 'p' },
                                            { label: 'Custom', value: 'custom' }
                                        ]}
                                        labelPosition="edge"
                                        className="softlite-select-control"
                                        onChange={(newTag) => setNewParentTag(newTag)}
                                    />
                                    {tag == 'custom' && (
                                        <TextControl
                                            label="Custom tag"
                                            value={attributes?.customHTML?.customTag}
                                            onChange={(value) => setCustomTag(value)}
                                            className="softlite-text-control"
                                        />
                                    )}
                                </PanelBody>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Margin</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <BacgroundControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>

                <div {...blockProps} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: attributes?.customHTML?.htmlContent }} />

                {css && (
                    <style type='text/css'>{css}</style>
                )}
            </>
        );
    },
    save: (props) => {
        const { attributes } = props;
        const htmlContent = attributes?.customHTML?.htmlContent ? attributes?.customHTML?.htmlContent : '';
        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-custom-html${advancedClassNames}`;
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

        return (
            <>
                <div className={allClassNames} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </>
        )
    },
});